import Reveal from "@/components/Reveal";

const NICHES = [
  "Compra-ventas de coches",
  "Concesionarios independientes",
  "Importadores de vehículos",
  "Detailing",
  "Talleres",
  "Tiendas de recambios y accesorios",
];

export default function ParaQuienEs() {
  return (
    <section id="para-quien-es" data-testid="para-quien-section" className="relative py-24 lg:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <Reveal className="lg:col-span-6">
            <div className="font-stencil text-xs text-[#00A0A0] tracking-widest mb-4">08 / PARA QUIÉN ES</div>
            <h2 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight leading-[0.95]">
              ESTO ES PARA
              <br />
              <span className="text-white/40">NEGOCIOS DEL</span>
              <br />
              <span className="font-stencil text-[#FFD700]">MOTOR.</span>
            </h2>
          </Reveal>

          <Reveal delay={150} className="lg:col-span-6 lg:pl-4">
            <p className="text-lg text-white/75 leading-relaxed font-body">
              Conocemos tu sector desde dentro. Nuestro origen está en la{" "}
              <span className="text-white">importación</span> y la{" "}
              <span className="text-white">compra-venta de vehículos</span>, y por eso hablamos tu idioma:
              stock, márgenes, peritajes, entregas, garantías.
            </p>

            <div className="mt-10">
              <div className="font-stencil text-xs text-white/40 tracking-widest mb-4">IDEAL PARA:</div>
              <div className="flex flex-wrap gap-2">
                {NICHES.map((n) => (
                  <span key={n} className="text-sm px-4 py-2 border border-white/15 hover:border-[#00A0A0] hover:bg-[#00A0A0]/5 text-white/80 hover:text-white transition-colors font-body">
                    {n}
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-white/10">
              <p className="font-stencil text-lg lg:text-2xl text-white uppercase leading-snug tracking-tight">
                Si vives del <span className="text-[#00A0A0]">motor</span> y necesitas que te{" "}
                <span className="text-[#00A0A0]">vean</span>, te{" "}
                <span className="text-[#00A0A0]">entiendan</span> y te{" "}
                <span className="text-[#FFD700]">elijan</span>,{" "}
                <span className="text-white/55">encajamos.</span>
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
